export default __webpack_public_path__ + "static/media/rafflesMalaysianRestaurant.32e742bd.png";